import { object, string } from "yup";

export const NewVehicleTypeSchema = object({
  name: string().required("Задолжително"),
});
